export class Language {
  isoCode: string = '';
  name: string = '';
}
